import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Zap, Download, Layers, Cpu } from 'lucide-react';
import { Button } from '../components/Button';
export const ProductDetail = () => {
  return <div className="min-h-screen pt-32 pb-24" data-id="element-311">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-312">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-lab-muted font-mono mb-8" data-id="element-313">
          <span data-id="element-314">Sistemas</span>
          <span data-id="element-315">/</span>
          <span className="text-white" data-id="element-316">Neural OS</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-317">
          {/* Left: Visuals */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="space-y-6" data-id="element-318">
            <div className="aspect-square md:aspect-[4/3] lg:aspect-square rounded-3xl glass-card relative overflow-hidden flex items-center justify-center bg-[#0a0a0f]" data-id="element-319">
              <div className="absolute inset-0 bg-gradient-to-br from-lab-violet/10 to-lab-blue/10" data-id="element-320" />

              {/* Abstract 3D-like representation */}
              <div className="relative z-10 w-64 h-64 border border-white/10 rounded-full flex items-center justify-center" data-id="element-321">
                <div className="absolute inset-0 border border-lab-violetLight/30 rounded-full animate-[spin_20s_linear_infinite]" data-id="element-322" />
                <div className="absolute inset-4 border border-lab-blueLight/30 rounded-full animate-[spin_15s_linear_infinite_reverse]" data-id="element-323" />
                <div className="w-32 h-32 bg-gradient-to-tr from-lab-violet to-lab-blue rounded-full blur-2xl opacity-40 animate-pulse-slow" data-id="element-324" />
                <Cpu className="absolute text-white" size={64} data-id="element-325" />
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4" data-id="element-326">
              {[1, 2, 3].map(i => <div key={i} className="aspect-video rounded-xl glass-card bg-[#0a0a0f] flex items-center justify-center border border-white/5 hover:border-white/20 transition-colors cursor-pointer" data-id="element-327">
                  <Layers className="text-lab-muted" size={24} data-id="element-328" />
                </div>)}
            </div>
          </motion.div>

          {/* Right: Info & Checkout */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="flex flex-col justify-center" data-id="element-329">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass-panel border-white/10 mb-6 w-fit" data-id="element-330">
              <span className="w-2 h-2 rounded-full bg-green-500 shadow-[0_0_10px_rgba(34,197,94,0.8)]" data-id="element-331"></span>
              <span className="text-xs font-mono text-white tracking-wider" data-id="element-332">
                v2.4 Disponible
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl font-display font-bold mb-4 leading-tight" data-id="element-333">
              Neural OS: Sistema de Segundo Cerebro
            </h1>

            <p className="text-xl text-lab-muted mb-8 font-light leading-relaxed" data-id="element-334">
              Una arquitectura digital construida en Notion para capturar,
              organizar y destilar conocimiento. Diseñado para pensadores,
              creadores y operadores de alto rendimiento.
            </p>

            <div className="flex items-end gap-4 mb-8" data-id="element-335">
              <span className="text-4xl font-mono font-bold text-white" data-id="element-336">
                $149
              </span>
              <span className="text-lg text-lab-muted font-mono mb-1 line-through" data-id="element-337">
                $299
              </span>
              <span className="text-sm text-lab-neon font-mono mb-2" data-id="element-338">USD</span>
            </div>

            <Button variant="primary" size="lg" icon={Zap} fullWidth className="mb-4" data-id="element-339">
              Adquirir Sistema Ahora
            </Button>

            <div className="flex items-center justify-center gap-6 text-sm text-lab-muted font-mono mb-12" data-id="element-340">
              <span className="flex items-center gap-2" data-id="element-341">
                <Shield size={16} data-id="element-342" /> Pago Seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-343">
                <Download size={16} data-id="element-344" /> Acceso Inmediato
              </span>
            </div>

            {/* Features List */}
            <div className="space-y-6" data-id="element-345">
              <h3 className="text-lg font-display font-semibold border-b border-white/10 pb-4" data-id="element-346">
                Especificaciones del Sistema
              </h3>
              <ul className="space-y-4" data-id="element-347">
                {['Framework de captura rápida (Mobile/Desktop)', 'Sistema de destilación progresiva de conocimiento', 'Dashboard operativo para gestión de proyectos', 'Base de datos relacional de recursos y notas', 'Video tutorial de implementación (45 min)', 'Acceso a actualizaciones de por vida'].map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-348">
                    <div className="mt-1 bg-lab-violet/20 p-1 rounded-full text-lab-violetLight" data-id="element-349">
                      <Check size={14} data-id="element-350" />
                    </div>
                    <span className="text-lab-muted" data-id="element-351">{feature}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
};